import { z } from "zod";

const emotionalImprintEnum = z.enum([
  "COMFORTED",
  "INSPIRED",
  "MOVED",
  "THOUGHTFUL",
  "UNSETTLED",
  "DISTURBED",
  "AMUSED",
  "CALM",
  "RESTLESS",
  "BORED",
  "FRUSTRATED",
  "CHANGED",
]);

const journalStatusEnum = z.enum([
  "WANT_TO_READ",
  "READING",
  "FINISHED",
  "SKIPPED",
]);

export const createJournalEntrySchema = z.object({
  bookId: z.string().min(1, "Book is required"),
  status: journalStatusEnum.default("READING").optional(),
  emotionalImprint: emotionalImprintEnum.nullable().optional(),
  reflection: z
    .string()
    .max(10000, "Reflection must be 10000 characters or less")
    .nullable()
    .optional(),
  memorableMoment: z
    .string()
    .max(500, "Memorable moment must be 500 characters or less")
    .nullable()
    .optional(),
  rating: z.number().int().min(1).max(5).nullable().optional(),
  highlights: z.array(z.string()).max(3).optional().default([]),
  summary: z
    .string()
    .max(140, "Summary must be 140 characters or less")
    .nullable()
    .optional(),
  isPublic: z.boolean().optional(),
  finishedDate: z.string().datetime().nullable().optional(),
  readingRoomId: z.string().nullable().optional(),
});

export const updateJournalEntrySchema = z.object({
  status: journalStatusEnum.optional(),
  emotionalImprint: emotionalImprintEnum.nullable().optional(),
  reflection: z
    .string()
    .max(10000, "Reflection must be 10000 characters or less")
    .nullable()
    .optional(),
  memorableMoment: z
    .string()
    .max(500, "Memorable moment must be 500 characters or less")
    .nullable()
    .optional(),
  rating: z.number().int().min(1).max(5).nullable().optional(),
  highlights: z.array(z.string()).max(3).optional(),
  summary: z
    .string()
    .max(140, "Summary must be 140 characters or less")
    .nullable()
    .optional(),
  isPublic: z.boolean().optional(),
  finishedDate: z.string().datetime().nullable().optional(),
  readingRoomId: z.string().nullable().optional(),
});

export const journalQuerySchema = z.object({
  status: journalStatusEnum.optional(),
  search: z.string().optional(),
  limit: z.coerce.number().min(1).max(500).default(20).optional(),
  page: z.coerce.number().min(1).default(1).optional(),
});

export const segmentImprintSchema = z.object({
  imprint: emotionalImprintEnum,
});

export type CreateJournalEntryInput = z.infer<typeof createJournalEntrySchema>;
export type UpdateJournalEntryInput = z.infer<typeof updateJournalEntrySchema>;
export type JournalQueryInput = z.infer<typeof journalQuerySchema>;
export type SegmentImprintInput = z.infer<typeof segmentImprintSchema>;
